import json from './sprite.js';

export default {
    handle: 'es_SPT11-Book-Birthday',
    label: 'es_SPT11-Book-Birthday',
    json,
};
